import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import Button, { ButtonVariant } from "components/base/Button";
import ModalDepositar from "./ModalDepositar";
import { ContaType } from "services/contaService";

interface BotaoDepositarProps {
    conta: ContaType;
    size?: "sm" | "lg";
    variant?: ButtonVariant;
    title?: string;
    showText?: boolean;
}

const BotaoDepositar: React.FC<BotaoDepositarProps> = ({
    conta,
    size = "sm",
    variant = "outline-success",
    title = "Depositar",
    showText = false
}) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <>
            <Button
                variant={variant}
                size={size}
                onClick={handleClick}
                title={title}
            >
                <FontAwesomeIcon icon={faArrowDown} className={showText ? "me-2" : ""} />
                {showText && "Depositar"}
            </Button>

            <ModalDepositar
                show={showModal}
                onHide={handleClose}
                conta={conta}
            />
        </>
    );
};

export default BotaoDepositar; 